import FormContainer from '@components/form/container'
import FormController from '@components/form/controller'
import { Control } from 'react-hook-form'
import uuid from 'react-uuid'
import { BaseFormPermission, FormStatusEnum, RightsCategory } from '@services/model/form/form.model'
import FormFreeText from '@components/form/freeText'
import { FormEIModel, InitEIForm, EiGeneralOptions } from '@services/model/form/form.EI.model'
import FormImageUpload from '@components/form/imageUpload'
import FormField from '@components/form/field'
import FormSignatureHistories from '@components/form/signatureHistories'
import { GlobalStateProps } from '@providers/globalStore'

export default ({
  control,
  getValues,
  globalState,
  formPermission,
  handleOnComplete,
}: {
  control: Control<FormEIModel>
  getValues: any
  globalState: GlobalStateProps
  formPermission: BaseFormPermission
  handleOnComplete: any
}) => {
  const UUID = uuid()

  return (
    <FormContainer fkey={`${UUID}-ei-d`}>
      <FormSignatureHistories
        formStatusList={globalState.formStatusList}
        histories={getValues('baseForm.formStatusHistories')}
        control={control}
        handleOnComplete={() => handleOnComplete()}
        endOfFlow={formPermission?.endOfFlow}
        userMetaList={globalState.userMetaList}
        roleMetaList={globalState.roleMetaList}
        disabled={!formPermission?.canUpdate}
      />
    </FormContainer>
  )
}
